// extracted by mini-css-extract-plugin
module.exports = {"related":"related_related__Ye08T","name":"related_name__aqJSo"};